module.exports = __webpack_public_path__ + "static/media/board.89511f13.png";